#!/usr/bin/env node
import "./sandbox-env-setup.ts";
import "./runtime-setup.ts";
import "../cli.ts";
